import type { ActionFunction } from 'react-router-dom';

export const action = () =>
  (async ({ request }) => {
    const { intent } = await request.json();

    switch (intent) {
      default:
        throw new Error(`Undefined intent '${intent}' for the action`);
    }
  }) satisfies ActionFunction;
